module.exports = __webpack_public_path__ + "static/media/5.320be677.jpg";